/**
 * Art Direction §7 and §13. The pipeline skips, fails and gates; rendering all of that as one
 * blank area teaches an editor that the tool is unreliable, and rendering "skipped" as "verified"
 * is a safety failure.
 *
 * There is no default `kind` — the caller must have decided which of the four this is.
 */

export type AbsenceKind = 'not_reached' | 'skipped' | 'failed' | 'empty' | 'not_built';

const KIND_LABEL = {
  not_reached: 'Aún no llega aquí',
  skipped: 'Omitido por una compuerta',
  failed: 'Falló',
  empty: 'Se ejecutó y no encontró nada',
  not_built: 'Etapa no construida',
} satisfies Record<AbsenceKind, string>;

type AbsenceStateProps = {
  kind: AbsenceKind;
  /** What is not here, in the editor's terms. */
  what: string;
  /** Which gate, which failure, or which stage has not run. */
  why?: string;
  /** The condition that would change it — even if the editor cannot trigger it. */
  wouldChange?: string;
  /** When the editor *can* trigger it from here. Absent everywhere the change is out of their hands. */
  action?: { label: string; onClick: () => void };
};

export function AbsenceState({ kind, what, why, wouldChange, action }: AbsenceStateProps) {
  return (
    <div className="absence" data-kind={kind}>
      <p className="absence__kind">{KIND_LABEL[kind]}</p>
      <p className="absence__what">{what}</p>
      {why && <p className="absence__why">{why}</p>}
      {wouldChange && <p className="absence__change">{wouldChange}</p>}
      {action && (
        <p className="absence__action">
          <button type="button" className="link-button" onClick={action.onClick}>
            {action.label}
          </button>
        </p>
      )}
    </div>
  );
}
